<div class="external-matches-page">
  <!-- Tab Content: Available Matches -->
  @if (activeTab === "matches") {
    <div class="tab-content" role="tabpanel">
      <!-- Helper Info Callout Banner -->
      <div class="matches-info-callout">
        <div class="callout-icon-wrap">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="callout-content">
          <span class="callout-title">External Partner Opportunities</span>
          <p class="callout-text">
            These matches appear when there are few internal organization
            matches, but your business profile has matched with opportunities
            from our external lending partners.
          </p>
        </div>
      </div>

      @if (isLoadingMatches) {
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading external matches...</p>
        </div>
      } @else if (matches.length === 0) {
        <div class="empty-state">
          <div class="empty-icon-wrap">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 21l-4.35-4.35M19 11a8 8 0 11-16 0 8 8 0 0116 0z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h3 class="empty-title">No External Matches Found</h3>
          <p class="empty-desc">
            There are currently no external matches available for your business
            profile. Please check back later as new partner opportunities become
            available.
          </p>
          <button type="button" class="empty-action-btn" (click)="goBack()">
            Return to Business Profile
          </button>
        </div>
      } @else {
        <div class="table-container">
          <table class="matches-table">
            <thead>
              <tr>
                <th>Product Details</th>
                <th>Category</th>
                <th>Terms &amp; Rates</th>
                <th style="width: 220px"></th>
              </tr>
            </thead>
            <tbody>
              @for (match of matches; track getProductId(match)) {
                <tr [class.row-applied]="isProductApplied(match)">
                  <td class="col-product">
                    <div class="product-cell-with-img">
                      @if (getProductImage(match)) {
                        <img
                          [src]="getProductImage(match)"
                          alt="Product"
                          class="product-thumb-img"
                          (error)="onProductImageError(match)"
                        />
                      } @else {
                        <div
                          class="product-placeholder-logo"
                          aria-label="Partner initials"
                        >
                          {{ getPartnerInitials(getLenderName(match)) }}
                        </div>
                      }
                      <div class="product-text-wrap">
                        <span class="product-name">{{
                          getProductName(match)
                        }}</span>
                        <span class="lender-sub">{{
                          getLenderName(match)
                        }}</span>
                      </div>
                    </div>
                  </td>
                  <td class="col-type">
                    <span class="type-badge">{{ getProductKind(match) }}</span>
                  </td>
                  <td class="col-terms">
                    <div class="terms-cell">
                      @if (getProductTerms(match)) {
                        <span class="term-line">
                          <strong>Terms:</strong> {{ getProductTerms(match) }}
                        </span>
                      }
                      @if (getProductRates(match)) {
                        <span class="term-line">
                          <strong>Rates:</strong> {{ getProductRates(match) }}
                        </span>
                      }
                      @if (!getProductTerms(match) && !getProductRates(match)) {
                        <span class="terms-muted"
                          >Standard partner terms apply</span
                        >
                      }
                    </div>
                  </td>
                  <td class="col-action">
                    <div class="action-buttons">
                      <button
                        type="button"
                        class="btn-view-details"
                        (click)="openDetailsModal(match)"
                        aria-label="View Details"
                      >
                        View Details
                      </button>
                      @if (isProductApplied(match)) {
                        <button
                          type="button"
                          class="btn-applied"
                          disabled
                          aria-label="Already applied"
                        >
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5 13l4 4L19 7"
                              stroke="currentColor"
                              stroke-width="2.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span>Applied</span>
                        </button>
                      } @else {
                        <button
                          type="button"
                          class="btn-apply"
                          [disabled]="applyingProductId !== null"
                          (click)="applyProduct(match)"
                          [title]="'Apply for ' + getProductName(match)"
                        >
                          @if (applyingProductId === getProductId(match)) {
                            <span class="spinner-small"></span>
                            <span>Applying...</span>
                          } @else {
                            <span>Apply</span>
                          }
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }

  <!-- Tab Content: Applied Leads -->
  @if (activeTab === "applied") {
    <div class="tab-content" role="tabpanel">
      <!-- Helper Info Callout Banner -->
      <div class="matches-info-callout">
        <div class="callout-icon-wrap">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="callout-content">
          <span class="callout-title"
            >Funding opportunities you have applied for</span
          >
          <p class="callout-text">
            Opportunities you applied for from external matches are listed here.
            The respective lending partners will review your submission and may
            contact you directly regarding next steps.
          </p>
        </div>
      </div>

      @if (isLoadingApplied) {
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading applied leads...</p>
        </div>
      } @else if (appliedLeads.length === 0) {
        <div class="empty-state">
          <div class="empty-icon-wrap">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h3 class="empty-title">No Applied Leads Yet</h3>
          <p class="empty-desc">
            You haven't applied for any external matches yet. Browse the
            Available Matches tab to review and apply for funding opportunities.
          </p>
          <button
            type="button"
            class="empty-action-btn"
            (click)="setTab('matches')"
          >
            View Available Matches
          </button>
        </div>
      } @else {
        <div class="table-container">
          <table class="matches-table applied-table">
            <thead>
              <tr>
                <th>Product Details</th>
                <th>Category</th>
                <th>Date Applied</th>
                <th style="width: 140px"></th>
              </tr>
            </thead>
            <tbody>
              @for (lead of appliedLeads; track lead.id) {
                <tr>
                  <td class="col-product">
                    <div class="product-cell-with-img">
                      @if (getAppliedProductImage(lead)) {
                        <img
                          [src]="getAppliedProductImage(lead)"
                          alt="Product"
                          class="product-thumb-img"
                          (error)="onAppliedImageError(lead)"
                        />
                      } @else {
                        <div
                          class="product-placeholder-logo"
                          aria-label="Partner initials"
                        >
                          {{ getPartnerInitials(getAppliedLenderName(lead)) }}
                        </div>
                      }
                      <div class="product-text-wrap">
                        <span class="product-name">{{
                          getAppliedProductName(lead)
                        }}</span>
                        <span class="lender-sub">{{
                          getAppliedLenderName(lead)
                        }}</span>
                        @if (isOlderSubmission(lead)) {
                          <span
                            class="badge-older"
                            title="Applied under a previous submission before profile update"
                          >
                            Older Submission
                          </span>
                        }
                      </div>
                    </div>
                  </td>
                  <td class="col-type">
                    <span class="type-badge">{{
                      getAppliedProductKind(lead)
                    }}</span>
                  </td>
                  <td class="col-date">
                    <span class="date-text">
                      {{ lead.created_at_utc | date: "MMM d, y, h:mm a" }}
                    </span>
                  </td>
                  <td class="col-action">
                    <div class="action-buttons">
                      <button
                        type="button"
                        class="btn-view-details"
                        (click)="openDetailsModalForLead(lead)"
                        aria-label="View Details"
                      >
                        View Details
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }

  <!-- Product & Partner Details Modal Popup -->
  @if (selectedMatchForDetails) {
    <app-popup
      class="external-match-details-popup"
      [heading]="getProductName(selectedMatchForDetails)"
      [confirmText]="getDetailsModalConfirmText()"
      cancelText="Close"
      [isConfirmDisabled]="isDetailsModalConfirmDisabled()"
      [showCloseIcon]="true"
      (confirmClicked)="onDetailsModalConfirm()"
      (cancelClicked)="closeDetailsModal()"
    >
      <!-- Popup Scrollable Body -->
      <div class="popup-details-body">
        <!-- Product Details Section -->
        <div class="modal-section">
          <h3 class="section-heading">Product Overview</h3>
          <div class="details-grid">
            <div class="detail-item">
              <span class="detail-label">Lender</span>
              <span class="detail-value">
                {{ getLenderName(selectedMatchForDetails) }}
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Category</span>
              <span class="detail-value">
                {{ getProductKind(selectedMatchForDetails) }}
              </span>
            </div>
            @if (selectedMatchForDetails.details.maxMoneyAmount) {
              <div class="detail-item">
                <span class="detail-label">Maximum Funding Amount</span>
                <span class="detail-value highlight">
                  {{
                    selectedMatchForDetails.details.maxMoneyAmount
                      | currency: "USD" : "symbol" : "1.0-0"
                  }}
                </span>
              </div>
            }
            @if (getProductRates(selectedMatchForDetails)) {
              <div class="detail-item">
                <span class="detail-label">Interest Rates</span>
                <span class="detail-value">
                  {{ getProductRates(selectedMatchForDetails) }}
                </span>
              </div>
            }
            @if (getProductTerms(selectedMatchForDetails)) {
              <div class="detail-item">
                <span class="detail-label">Terms</span>
                <span class="detail-value">
                  {{ getProductTerms(selectedMatchForDetails) }}
                </span>
              </div>
            }
            @if (getTimeToFund(selectedMatchForDetails)) {
              <div class="detail-item">
                <span class="detail-label">Time to Fund</span>
                <span class="detail-value">
                  {{ getTimeToFund(selectedMatchForDetails) }}
                </span>
              </div>
            }
            @if (selectedMatchForDetails.details.collateralType) {
              <div class="detail-item">
                <span class="detail-label">Collateral Required</span>
                <span class="detail-value">
                  {{ selectedMatchForDetails.details.collateralType }}
                </span>
              </div>
            }
            @if (selectedMatchForDetails.details.loanType) {
              <div class="detail-item">
                <span class="detail-label">Loan Type</span>
                <span class="detail-value">
                  {{
                    formatLoanType(selectedMatchForDetails.details.loanType)
                  }}
                </span>
              </div>
            }
            @if (selectedMatchForDetails.details.paymentFrequency) {
              <div class="detail-item">
                <span class="detail-label">Payment Frequency</span>
                <span class="detail-value">
                  {{ selectedMatchForDetails.details.paymentFrequency }}
                </span>
              </div>
            }
            @if (selectedMatchForDetails.details.originationFee) {
              <div class="detail-item">
                <span class="detail-label">Origination Fee</span>
                <span class="detail-value">
                  {{
                    getFeeText(selectedMatchForDetails.details.originationFee)
                  }}
                </span>
              </div>
            }
            @if (selectedMatchForDetails.details.applicationFee) {
              <div class="detail-item">
                <span class="detail-label">Application Fee</span>
                <span class="detail-value">
                  {{
                    getFeeText(selectedMatchForDetails.details.applicationFee)
                  }}
                </span>
              </div>
            }
          </div>
        </div>

        <!-- Partner Details Section -->
        <div class="modal-section">
          <h3 class="section-heading">About the Partner</h3>
          @if (selectedMatchForDetails.partner.description) {
            <p class="partner-description">
              {{ selectedMatchForDetails.partner.description }}
            </p>
          }
          <div class="details-grid">
            @if (selectedMatchForDetails.partner.headquarters) {
              <div class="detail-item">
                <span class="detail-label">Headquarters</span>
                <span class="detail-value">
                  {{ selectedMatchForDetails.partner.headquarters }}
                </span>
              </div>
            }
            @if (selectedMatchForDetails.partner.areasServed) {
              <div class="detail-item">
                <span class="detail-label">Areas Served</span>
                <span class="detail-value">
                  {{ selectedMatchForDetails.partner.areasServed }}
                </span>
              </div>
            }
            @if (selectedMatchForDetails.partner.amountFinancedToDate) {
              <div class="detail-item">
                <span class="detail-label">Financed to Date</span>
                <span class="detail-value">
                  {{
                    selectedMatchForDetails.partner.amountFinancedToDate
                      | currency: "USD" : "symbol" : "1.0-0"
                  }}
                </span>
              </div>
            }
            @if (selectedMatchForDetails.partner.smallBusinessesServed) {
              <div class="detail-item">
                <span class="detail-label">Small Businesses Served</span>
                <span class="detail-value">
                  {{
                    selectedMatchForDetails.partner.smallBusinessesServed
                      | number
                  }}
                </span>
              </div>
            }
            @if (selectedMatchForDetails.partner.establishedYear) {
              <div class="detail-item">
                <span class="detail-label">Established</span>
                <span class="detail-value">
                  {{ selectedMatchForDetails.partner.establishedYear }}
                </span>
              </div>
            }
            @if (selectedMatchForDetails.partner.languages) {
              <div class="detail-item">
                <span class="detail-label">Languages Supported</span>
                <span class="detail-value">
                  {{ selectedMatchForDetails.partner.languages }}
                </span>
              </div>
            }
            @if (selectedMatchForDetails.partner.website) {
              <div class="detail-item">
                <span class="detail-label">Website</span>
                <a
                  [href]="selectedMatchForDetails.partner.website"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="detail-link"
                >
                  {{ selectedMatchForDetails.partner.website }}
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="external-icon"
                  >
                    <path
                      d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3"
                    />
                  </svg>
                </a>
              </div>
            }
          </div>
        </div>
      </div>
    </app-popup>
  }
</div>
